module.exports = __webpack_public_path__ + "static/media/svs-logo.e4d775ad.png";